import * as React from 'react';

//hook
import { useState } from 'react';
import { NotificationConsumer } from '../hooks/context/NotificationContext';
import { UserConsumer } from '../hooks/context/UserContext';

//api
import { PutProfile } from '../api/profile/PutProfile';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//type
import { profileReqType } from '../api/profile/type/ProfileType';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface updateProfileProps {
    openUpdateProfile: boolean,
    setOpenUpdateProfile: (open:boolean) =>void
}

const UpdateProfile = ({openUpdateProfile, setOpenUpdateProfile}: updateProfileProps) => {
    const { t } = useTranslation();
    let [loading, setLoading] = useState<boolean>(false)
    let {setNoteMessage, setShowMessage, setStatusCode} = NotificationConsumer()
    let {userData, setUserData, theme} = UserConsumer()

    const updateProfileSchema = Yup.object().shape({
    full_name: Yup.string().required(t("full_name_required")),
    email: Yup.string().email(t("invalid_email")).required(t("email_required")),
    phone: Yup.string().required(t("phone_required")),
    });

    const handleSubmit = async (values: profileReqType, id:number)=> {
      try {
          setLoading(true)
          const result = await PutProfile(values, id);
          console.log('update profile successful:');
          if(result.code == 200) {
          setNoteMessage(result.message)
          setShowMessage(true)
          setStatusCode(result.code)
          setUserData(result.data)
          }
          else {
          setNoteMessage(result.message)
          setShowMessage(true)
          setStatusCode(result.code)
          }
          setOpenUpdateProfile(false)
      }
      catch (error:any) {
          console.error('update profile failed', error);
          setNoteMessage(error.response.data.message)
          setShowMessage(true)
          setStatusCode(error.status)
      }
      finally {
          setLoading(false)
      }
    }

  return (
    <Dialog 
    open={openUpdateProfile}
    onClose={()=>setOpenUpdateProfile(false)}
    slots={{
        transition: Transition,
    }}
    disableRestoreFocus
    >
        <DialogTitle>{t("update_account")}</DialogTitle>
        <DialogContent>
        <Formik
        initialValues={{ full_name: userData?.full_name, email: userData?.email, phone: userData?.phone }}
        validationSchema={updateProfileSchema}
        onSubmit={(values) => handleSubmit(values, userData!.id)}
        >
        {({ values,touched, errors,setFieldValue }) => (
        <Form>
            <div className="sm:flex gap-2 mt-2">
                <Field
                    as={TextField}
                    name="full_name"
                    label={t("full_name")}
                    className="sm:w-1/2 w-full"
                    helperText={touched.full_name && errors.full_name ? errors.full_name : ""}
                    error={touched.full_name && Boolean(errors.full_name)}
                />
                <Field
                    as={TextField}
                    name="email"
                    type="email"
                    label={t("email")}
                    className="sm:w-1/2 w-full"
                    helperText={touched.email && errors.email ? errors.email : ""}
                    error={touched.email && Boolean(errors.email)}
                />
            </div>
            <div className="mt-5">
                <PhoneInput
                  country={"sy"}
                  enableSearch={true}
                  value={values.phone}
                  onChange={(phone) => setFieldValue("phone", phone.startsWith("+") ? phone : `+${phone}`)}
                  inputStyle={{
                    borderRadius: "4px",
                    width: "100%",
                    height: "56px",
                    border: touched.phone && errors.phone ? "1px solid red" : "",
                  }}
                  buttonStyle={{ marginRight: "8px", direction: "ltr" }}
                  containerStyle={{
                    display: "flex",
                    flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
                  }}
                  inputProps={{
                    autoComplete: "phone",
                  }}
                />
                <div className="text-red-500 text-sm mt-1">
                  {touched.phone && errors.phone ? errors.phone : ""}
                </div>
              </div>

            <DialogActions className={` ${i18n.language === "en" ? "!justify-start" : "!justify-start"}`}>
            <Button className={`w-full !bg-customerColor !text-white`} type="submit">
                {loading 
                ? <CircularProgress className='w-1 h-1'/>
                :t("confirm")
                }
            </Button>
            </DialogActions>
        </Form>
        )}
        </Formik>
        </DialogContent>
    </Dialog>
  )
}

export default UpdateProfile